import * as React from 'react';

import { formatPhone } from '../../utils/formatters/phone';
import { ShowPhone } from '../../components/ShowPhone';
import { useApplicationContext } from '../../context/applicationContext';
import { useOfferContext } from '../OfferContext';
import { fetchComagic } from '../../services/fetchComagic';

export function ShowPhoneButtonContainer() {
  const [dynamicPhone, setDynamicPhone] = React.useState<string | null>(null);

  const {
    phones: offerPhones,
    author: { name, isFromLeadFactory },
    calltracking: { siteBlockId },
    showWarningMessage,
    id,
    tracking: { onPhoneShow },
  } = useOfferContext();

  const phones = React.useMemo(() => offerPhones.map(formatPhone), [offerPhones]);

  const dynamicPhones = dynamicPhone ? [dynamicPhone] : phones;

  const context = useApplicationContext();

  const onClick = React.useCallback(async () => {
    onPhoneShow();

    const dynamicPhone = await fetchComagic(
      { comagicId: siteBlockId, placeType: 'stickyBottom', announcementId: id },
      context,
    );

    if (dynamicPhone) {
      setDynamicPhone(formatPhone(dynamicPhone));
    }
  }, [onPhoneShow, siteBlockId, id, context]);

  return (
    <ShowPhone
      phones={dynamicPhones}
      name={name}
      withNote={!isFromLeadFactory}
      trackClick={onClick}
      showWarningMessage={showWarningMessage}
    />
  );
}
